import { Swal, SweetAlertOptions, toast} from 'external/react'
import { convertDateToText } from 'utilities/text'

export const notifySuccess = (message: string) => {
	toast.success(message, {
		position: 'top-right',
		autoClose: 5000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
		theme: "colored"
	})
}

export const notifyWarning = (message: string) => {
	toast.warning(message, {
		position: 'top-right',
		autoClose: 5000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
        theme: "colored"
	})
}

export const notifyError = (message: string) => {
	toast.error(message, {
		position: 'top-right',
		autoClose: 5000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
		theme: "colored"
	})
}

export function showConfirmDialog (text: string, options?: Partial<SweetAlertOptions>) {
	const dialogOptions: SweetAlertOptions = {
		title: '',
		text,
		icon: 'warning',
		showCancelButton: true,
		confirmButtonColor: '#1797D0',
		cancelButtonColor: '#e9e9e9',
		confirmButtonText: 'Confirmar',
		cancelButtonText: 'Cancelar',
		reverseButtons: true,
		...(options || {}),
	} as SweetAlertOptions
	return Swal.fire(dialogOptions)
}

export function showConfirmCancelSubscription(subscriptionEnds) {
	const title = `<h3>¿Estás seguro de que deseas cancelar tu suscripción?</h3>`
	const text = `Perderás acceso a los beneficios a partir del <b>${convertDateToText(subscriptionEnds, true)}.</b>`
	const html = `Perderás acceso a los beneficios a partir del <b>${convertDateToText(subscriptionEnds, true)}.</b>`
	return showConfirmDialog(text, {
		title, html, cancelButtonText: 'No cancelar', confirmButtonText: 'Continuar'
	})
}

export const alert = async () => {
	return Swal.fire({
		title: 'Are you sure?',
		text: "You won't be able to revert this!",
		icon: 'warning',
		showCancelButton: true,
		confirmButtonColor: '#3085d6',
		cancelButtonColor: '#d33',
		confirmButtonText: 'Yes, delete it!',
	}).then((result) => {
		if (result.isConfirmed) {
			Swal.fire({
				title: 'Deleted!',
				text: 'Your file has been deleted.',
				icon: 'success',
			});
		}
	});
};